import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import "./whatsappChatWidget.css";

const SUPPORT_MESSAGE = "Hi, I would need support regarding ";
const WHATSAPP_URL = `https://wa.me/447739343143?text=${encodeURIComponent(SUPPORT_MESSAGE)}`;
const PANEL_ID = "whatsapp-chat-widget-panel";

const WhatsAppIcon = () => (
  <svg
    aria-hidden="true"
    className="whatsapp-chat-widget__icon"
    focusable="false"
    viewBox="0 0 32 32"
  >
    <path
      fill="currentColor"
      d="M16.03 3.2c-7.04 0-12.76 5.72-12.76 12.76 0 2.24.59 4.42 1.7 6.34L3.16 28.8l6.66-1.75a12.7 12.7 0 0 0 6.2 1.58h.01c7.04 0 12.77-5.72 12.77-12.76 0-3.41-1.33-6.62-3.74-9.04A12.68 12.68 0 0 0 16.03 3.2Zm0 23.27h-.01c-1.96 0-3.89-.53-5.57-1.53l-.4-.24-3.95 1.04 1.06-3.86-.26-.4a10.54 10.54 0 0 1-1.62-5.52c0-5.93 4.82-10.75 10.76-10.75 2.87 0 5.57 1.12 7.6 3.15a10.68 10.68 0 0 1 3.15 7.6c0 5.93-4.83 10.75-10.76 10.75Zm5.9-8.05c-.32-.16-1.91-.94-2.2-1.05-.3-.11-.51-.16-.73.16-.22.32-.84 1.05-1.03 1.26-.19.22-.38.24-.7.08-.32-.16-1.37-.51-2.61-1.62a9.75 9.75 0 0 1-1.8-2.24c-.19-.32-.02-.5.14-.66.15-.14.32-.38.49-.57.16-.19.22-.32.32-.54.11-.22.05-.41-.03-.57-.08-.16-.73-1.75-1-2.4-.26-.63-.53-.54-.73-.55h-.62c-.22 0-.57.08-.86.4-.3.32-1.13 1.1-1.13 2.69s1.16 3.12 1.32 3.34c.16.22 2.28 3.48 5.52 4.88.77.33 1.37.53 1.84.68.77.24 1.48.21 2.04.13.62-.09 1.91-.78 2.18-1.54.27-.75.27-1.4.19-1.54-.08-.14-.3-.22-.62-.38Z"
    />
  </svg>
);

const WhatsAppChatWidget = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const widgetRef = useRef(null);
  const launcherRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsOpen(false);
        launcherRef.current?.focus();
      }
    };

    const handlePointerDown = (event) => {
      if (widgetRef.current && !widgetRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("pointerdown", handlePointerDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("pointerdown", handlePointerDown);
    };
  }, [isOpen]);

  if (location.pathname.startsWith("/mc/") || location.pathname.startsWith("/admin/product-analytics")) return null;

  return (
    <div className="whatsapp-chat-widget" ref={widgetRef}>
      {isOpen && (
        <section
          aria-labelledby="whatsapp-chat-widget-title"
          className="whatsapp-chat-widget__panel"
          id={PANEL_ID}
        >
          <button
            aria-label="Close WhatsApp chat panel"
            className="whatsapp-chat-widget__close"
            onClick={() => setIsOpen(false)}
            type="button"
          >
            <span aria-hidden="true">×</span>
          </button>
          <div className="whatsapp-chat-widget__panel-icon">
            <WhatsAppIcon />
          </div>
          <p className="whatsapp-chat-widget__eyebrow">Gigathlon support</p>
          <h2 id="whatsapp-chat-widget-title">Start a Conversation</h2>
          <p className="whatsapp-chat-widget__copy">
            Need help with your passport, a stamp, or finding your next show? Message us on WhatsApp
            and we will help you get moving.
          </p>
          <a
            className="whatsapp-chat-widget__cta"
            href={WHATSAPP_URL}
            rel="noopener noreferrer"
            target="_blank"
          >
            <WhatsAppIcon />
            <span>Open WhatsApp</span>
          </a>
        </section>
      )}

      <button
        aria-controls={PANEL_ID}
        aria-expanded={isOpen}
        aria-label="Toggle WhatsApp chat panel"
        className="whatsapp-chat-widget__launcher"
        onClick={() => setIsOpen((current) => !current)}
        ref={launcherRef}
        type="button"
      >
        <WhatsAppIcon />
        <span className="whatsapp-chat-widget__launcher-text">Need help? Chat with us</span>
      </button>
    </div>
  );
};

export default WhatsAppChatWidget;
